export const environment = {
  production: false,
  apiUrl: 'https://api-dev.zehn.me/api/v1/', // Set your dynamic base URL here
  // apiUrl: 'http://127.0.0.1:8000/api/v1/', // Set your dynamic base URL here
  clientId: '867594206411-garbb88ffmfj9nks54mdnimfch88i79c.apps.googleusercontent.com'
};
